function wait(ms, signal) {
    return new Promise((resolve, reject) => {
        // Already aborted is the same answer as aborted halfway, given sooner: a run whose signal was
        // cancelled before it started has nothing to report, and waiting the full delay to then
        // *succeed* would teach the preview that a server ignores cancellation.
        if (signal?.aborted) {
            reject(new DOMException("aborted", "AbortError"));
            return;
        }
        const abort = () => {
            clearTimeout(timer);
            reject(new DOMException("aborted", "AbortError"));
        };
        const timer = setTimeout(() => {
            signal?.removeEventListener("abort", abort);
            resolve();
        }, ms);
        signal?.addEventListener("abort", abort, { once: true });
    });
}
/** Builds a mock async validator matching `MdyAsyncValidatorFn` — for wiring into a field's server-validation slot in the live preview. */
export function createMockAsyncValidator(config = {}) {
    return async (value, ctx) => {
        await wait(config.delayMs ?? 300, ctx.signal);
        if (config.forceNetworkFailure)
            throw new Error("Mock network failure");
        if (config.forceError)
            return Array.isArray(config.forceError) ? config.forceError : [config.forceError];
        if (config.validValues && typeof value === "string" && !config.validValues.includes(value)) {
            return [`"${value}" is not a recognized value`];
        }
        return [];
    };
}
/** Builds a mock submit action — for wiring into `form.submit()` in the live preview. */
export function createMockSubmitAction(config = {}) {
    return async () => {
        await wait(config.delayMs ?? 300);
        if (config.forceNetworkFailure)
            throw new Error("Mock network failure");
        if (config.forceError) {
            const messages = Array.isArray(config.forceError) ? config.forceError : [config.forceError];
            return messages.map((message) => ({ path: null, kind: "server", message }));
        }
    };
}
